import styled from 'styled-components';

import { CFG_ANIM } from '../../../../../../theme/configurator-tokens';
import { FINISH } from '../../finish.tokens';

/**
 * Screen rectangle measured from the phone asset (792×1619): the transparent
 * inner region, expressed as percentages so it tracks the frame at any scale.
 */
export const Root = styled.div<{ $fit: 'height' | 'width' }>`
  position: relative;
  aspect-ratio: 792 / 1619;
  flex-shrink: 0;
  ${({ $fit }) =>
    $fit === 'width'
      ? 'width: 100%;'
      : 'height: 100%; max-height: 768px;'}
`;

export const Screen = styled.div<{ $radius: number; $bg?: string }>`
  position: absolute;
  left: 5.429%;
  top: 2.532%;
  width: 89.141%;
  height: 94.873%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* Own stacking context so the loading placeholder's z-index stays scoped here and
     can't escape above the frame PNG (a later sibling) — otherwise the overlay paints
     over the bezel/notch instead of being clipped by the cut-out like the iframe. */
  isolation: isolate;
  background: ${({ $bg }) => $bg ?? FINISH.phoneScreenBg};
  border-radius: ${({ $radius }) => $radius}px;
`;

/* Notch (dynamic island) bottom sits ~6% down the screen — top bar clears it. */
export const TopBar = styled.div<{ $color?: string }>`
  flex-shrink: 0;
  height: 6.3%;
  background: ${({ $color }) => $color ?? 'transparent'};
`;

export const BottomBar = styled.div<{ $color?: string }>`
  flex-shrink: 0;
  height: 4.2%;
  background: ${({ $color }) => $color ?? 'transparent'};
  /* While the iframe loads the strip matches the top bar (one flat colour);
     once loaded it eases to the site's own bottom-nav colour. */
  transition: background-color ${CFG_ANIM.PREVIEW_FADE_MS}ms ease;
`;

export const Content = styled.div`
  position: relative;
  min-height: 0;
  flex: 1;
  overflow: hidden;
`;

export const Zoom = styled.div<{ $width: number; $height: string; $scale: number }>`
  position: absolute;
  left: 0;
  top: 0;
  transform-origin: top left;
  width: ${({ $width }) => $width}px;
  height: ${({ $height }) => $height};
  transform: scale(${({ $scale }) => $scale});
`;

export const Overlay = styled.img`
  pointer-events: none;
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  user-select: none;
`;
